/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
  loading: {
    top: '45%',
    width: "3rem",
    height: "100%",
    position: "absolute",
    zIndex: 10000,
  },
  loaderInside: {
    top: '45%',
    left: '45%',
    width: "3rem",
    height: "100%",
    position: "absolute",
    zIndex: 10000,
  }
}));

export default useStyles;
